import axios from "axios";

import {
  GET_CATEGORY_API,
  GET_CITY_API,
  GET_CITY_BY_STATE_ID_API,
  GET_STATE_API,
  GET_VENUE_API,
  GET_VENUE_BY_CITY_ID_API,
  GET_FEATURED_EVENT_API,
  GET_COUNT_API,
  GET_LATEST_BLOG_API,
  GET_SPONSOR_API,
  MAIN_API,
  GET_SEARCH_EVENT_API,
  GET_EVENT_BY_ID_API,
  GET_SESSION_BY_DAY_ID_API,
  REGISTER_API,
  VERIFY_EMAIL_API,
  GET_APP_SETTINGS_API,
  LOGIN_API,
  GOOGLE_USER_INFO_API,
  SOCIAL_LOGIN_API,
  CHECK_EMAIL_API,
  VERIFY_OTP_API,
  FORGOT_PASSWORD_API,
  SEND_MESSAGE_API,
  SUBMIT_REGRET_API,
  GET_ALL_BLOG_API,
  GET_BLOG_BY_ID_API,
  GET_CART_API,
  ADD_CART_API,
  REMOVE_CART_API,
  UPDATE_CART_API,
  APPLY_DISCOUNT_API,
  GET_DISCOUNT_API,
  CHECKOUT_API,
  VERIFY_PAYMENT_API,
  GET_ORDER_API,
  POST_REVIEW_API,
  GET_ORDER_BY_ID_API,
  GET_MY_EVENTS_API,
  GET_MY_EVENT_DETAIL_API,
  GET_SEARCH_SUGGESTION_API,
  GET_EVENT_SPONSOR_API,
  GET_ALL_BARS_API,
  GET_BAR_BY_ID_API,
  GET_BAR_AVAILABILITY_API,
  HOLD_RESERVATION_API,
  CREATE_RESERVATION_API,
  GET_RESERVATION_STATUS_API,
  GET_MY_RESERVATIONS_API,
  GET_BEAUTY_SALONS_API,
  CREATE_VENUE_REVIEW_API,
  GET_VENUE_REVIEWS_API,
  GET_BEAUTY_SALON_API,
  GET_BEAUTY_AVAILABILITY_API,
  HOLD_BEAUTY_APPOINTMENT_API,
  CREATE_BEAUTY_RESERVATION_API,
  GET_ALL_CLUBS_API,
  GET_OPEN_MATCHES_API,
  GET_MY_OPEN_MATCHES_API,
  GET_OPEN_MATCH_API,
  GET_OPEN_MATCH_BY_SHARE_API,
  OPEN_MATCH_ME_API,
  LEAVE_OPEN_MATCH_API,
  CANCEL_OPEN_MATCH_API,
  JOIN_OPEN_MATCH_API,
  CREATE_OPEN_MATCH_API,
  GET_CLUB_BY_ID_API,
  GET_CLUB_AVAILABILITY_API,
  GET_CLUB_PRICE_API,
  HOLD_CLUB_RESERVATION_API,
  CREATE_CLUB_RESERVATION_API,
  GET_CLUB_BIRTHDAY_AVAILABILITY_API,
  CREATE_CLUB_BIRTHDAY_RESERVATION_API,
  CREATE_CLUB_BIRTHDAY_REQUEST_API,
  GET_BIRTHDAY_REQUEST_API,
  PAY_BIRTHDAY_REQUEST_API,
  GET_POPUP_IMAGE_API,
  UPDATE_PROFILE_API,
  CHANGE_PASSWORD_API,
  DELETE_ACCOUNT_API,
  GET_ACTIVE_BANNERS_API,
GET_ACTIVE_BANNER_BY_CODE_API,
  ACCEPT_TICKET_TRANSFER_API,
  INITIATE_TICKET_TRANSFER_API,
  GET_PREVIEW_EVENT_API,
  GET_PREVIEW_STATUS_API,
  ZOCO_CANJEAR_API,
  ZOCO_REFRESCAR_API,
  ZOCO_SALIR_API,
  ORG_CLUB_STATS_API,
  ORG_BEAUTY_STATS_API,
} from "./apilist";
import { store } from "../redux/store/store";
import { LOGOUT_SUCCESS, LOGIN_SUCCESS, SESION_ZOCO_RENOVADA } from "../redux/actions/action";
import { esSesionDeZoco, urlDelPortal } from "../helpers/zoco";

/*
  Una sola renovación de Zoco en vuelo. El token de Zoco dura sesenta minutos, y cuando vence
  varias pantallas del panel reciben el 401 a la vez. Zoco rota el refresh al usarlo: si cada una
  pidiera el suyo, solo la primera acertaría y las demás echarían a la persona con un refresh ya
  gastado. Es `renovarSesionUnaVez` del front del PDV (compartido/api/http.ts).

  Devuelve el token nuevo, o null si la sesión se terminó.
*/
let renovacionZocoEnVuelo = null;

const renovarSesionZocoUnaVez = () => {
  if (renovacionZocoEnVuelo) return renovacionZocoEnVuelo;

  renovacionZocoEnVuelo = (async () => {
    try {
      const { refreshToken } = store.getState().auth;
      const res = await axios.post(MAIN_API + ZOCO_REFRESCAR_API, { refreshToken });
      const { token, refreshToken: nuevoRefreshToken } = res.data.info;
      store.dispatch({ type: SESION_ZOCO_RENOVADA, payload: { accessToken: token, refreshToken: nuevoRefreshToken } });
      return token;
    } catch {
      return null;
    } finally {
      renovacionZocoEnVuelo = null;
    }
  })();

  return renovacionZocoEnVuelo;
};

axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const reffreshToken = store.getState().auth.refreshToken;
    const originalRequest = err.config || {};
    const status = err?.response?.status;
    const requestUrl = originalRequest?.url || "";
    // Los de Zoco también: un 401 de /api/zoco/refrescar quiere decir "la sesión se terminó",
    // no "renová y probá de nuevo".
    const isRefreshRequest = requestUrl.includes("/api/app/user/refreshToken") || requestUrl.includes("/api/zoco/");

    // Do not try to refresh on the refresh endpoint itself, or when no refresh token exists
    if (isRefreshRequest || !reffreshToken) {
      return Promise.reject(err);
    }

    if ((status === 402 || status === 401) && !originalRequest._retry) {
      originalRequest._retry = true;

      // Una sesión que salió del canje de Zoco se renueva contra Zoco: el refresh propio de
      // Tickets no la conoce.
      if (esSesionDeZoco(store.getState().auth)) {
        // Si el pedido salió con un token que ya se renovó —su 401 llegó después de que otra
        // pantalla renovara—, se repite con el vigente: renovar de nuevo gastaría otro refresh.
        const vigente = store.getState().auth.accessToken;
        const enviado = String(originalRequest.headers?.Authorization || "").replace(/^Bearer /, "");
        const accessToken = vigente && enviado && enviado !== vigente ? vigente : await renovarSesionZocoUnaVez();
        if (!accessToken) {
          // El refresh venció, o Zoco cortó la sesión: le quitaron el acceso o apagaron el
          // negocio (03-seguridad, regla 3). Se entra por el portal, así que se vuelve ahí.
          store.dispatch({ type: LOGOUT_SUCCESS });
          window.location.replace(urlDelPortal("/"));
          return Promise.reject(err);
        }
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      }

      try {
        const refreshToken = reffreshToken;
        const res = await axios.post(`${MAIN_API}/api/app/user/refreshToken`, { refreshToken });

        const accessToken = res.data.info.token;
        const newRefreshToken = res.data.info.refreshToken;
        const user = {
          id: res.data.info.user._id ?? res.data.info.user.id,
          email: res.data.info.user.email,
          name: res.data.info.user.name,
          role: res.data.info.user.role,
          dni: res.data.info.user.dni,
        };

        store.dispatch({ type: LOGIN_SUCCESS, payload: { accessToken, refreshToken: newRefreshToken, user } });

        // Retry the original request with the new token
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return axios(originalRequest);
      } catch (refresherr) {
        console.error("err refreshing token:", refresherr);
        // If refresh fails, ensure user is logged out to prevent further loops
        try {
          store.dispatch({ type: LOGOUT_SUCCESS });
        } catch {}
        return Promise.reject(refresherr);
      }
    }

    if (status === 423) {
      store.dispatch({ type: LOGOUT_SUCCESS });
      window.alert("Your session has expired. Please login again.");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

/* ---------------------------- ALL category API ---------------------------- */
export const getCategory = () => axios.get(MAIN_API + GET_CATEGORY_API);
/* ---------------------------- END category API ---------------------------- */
/* ---------------------------- ALL state API ---------------------------- */
export const getState = () => axios.get(MAIN_API + GET_STATE_API);
/* ---------------------------- END state API ---------------------------- */
/* ---------------------------- ALL city API ---------------------------- */
export const getCity = () => axios.get(MAIN_API + GET_CITY_API);
export const getCityByStateId = (data) => axios.post(MAIN_API + GET_CITY_BY_STATE_ID_API, data);
/* ---------------------------- END city API ---------------------------- */
/* ---------------------------- ALL venue API ---------------------------- */
export const getVenue = () => axios.get(MAIN_API + GET_VENUE_API);
export const getVenueByCityId = (data) => axios.post(MAIN_API + GET_VENUE_BY_CITY_ID_API, data);
/* ---------------------------- END venue API ---------------------------- */
/* ---------------------------- ALL event API ---------------------------- */
export const getFeaturedEvent = () => axios.get(MAIN_API + GET_FEATURED_EVENT_API);
export const getCount = () => axios.get(MAIN_API + GET_COUNT_API);
export const getSearchEvent = (data, page) => axios.post(MAIN_API + GET_SEARCH_EVENT_API + page, data);
export const getEventById = (id) => axios.get(MAIN_API + GET_EVENT_BY_ID_API + id);
export const getSessionByDayId = (data) => axios.post(MAIN_API + GET_SESSION_BY_DAY_ID_API, data);
export const getSearchSuggestion = (data) => axios.post(MAIN_API + GET_SEARCH_SUGGESTION_API, data);
export const getEventSponsor = (data) => axios.post(MAIN_API + GET_EVENT_SPONSOR_API, data);
export const getAllBarsApi = (params = {}) =>
  axios.get(MAIN_API + GET_ALL_BARS_API, { params });
export const getBarByIdApi = (id) => axios.get(MAIN_API + GET_BAR_BY_ID_API(id));
export const getBarAvailabilityApi = (id, date) =>
  axios.get(MAIN_API + GET_BAR_AVAILABILITY_API(id, date));
export const holdReservationApi = (data, token) =>
  axios.post(MAIN_API + HOLD_RESERVATION_API, data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
export const createReservationApi = (data, token) =>
  axios.post(MAIN_API + CREATE_RESERVATION_API, data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
export const getReservationStatusApi = (barId, code) =>
  axios.get(MAIN_API + GET_RESERVATION_STATUS_API(barId, code));
export const getMyReservationsApi = (token) =>
  axios.get(MAIN_API + GET_MY_RESERVATIONS_API, { headers: { Authorization: `Bearer ${token}` } });
export const cancelReservationApi = (id, token) =>
  axios.post(MAIN_API + `/api/app/reservation/${id}/cancel`, {}, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
/* ---------------------------- ALL club (canchas) API ---------------------------- */
export const getAllClubsApi = (params = {}) =>
  axios.get(MAIN_API + GET_ALL_CLUBS_API, { params });
// Listado público de partidos abiertos (T4): params de filtros + page/limit; responde info:{matches,page,limit,total,hasMore}.
export const getOpenMatchesApi = (params = {}) =>
  axios.get(MAIN_API + GET_OPEN_MATCHES_API, { params });
// Detalle público (T3): `info.match` = resumen + clubAddress. Por id o por el token del link de compartir.
export const getOpenMatchByIdApi = (id) => axios.get(MAIN_API + GET_OPEN_MATCH_API(id));
export const getOpenMatchByShareTokenApi = (shareToken) =>
  axios.get(MAIN_API + GET_OPEN_MATCH_BY_SHARE_API(shareToken));
// Sumarse (T3, optionalAuth): responde info:{match, manageToken, event}; 409 = no abierto, cerrado, lleno o ya anotado.
// Crear (T2, optionalAuth): 201 info:{match, matchId, shareToken, manageToken, reservationCode}; 403 club sin la función, 409 turno tomado o cierre pasado.
export const createOpenMatchApi = (body, token) =>
  axios.post(MAIN_API + CREATE_OPEN_MATCH_API, body, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
export const joinOpenMatchApi = (id, body) => axios.post(MAIN_API + JOIN_OPEN_MATCH_API(id), body);
// Link de gestión (T11). El manageToken viaja solo en el header `x-manage-token` (nunca en la URL ni en logs).
// /me -> info:{match, me:{playerId,name,isCreator,left,canLeave,leaveBlockedReason,canCancel}}; 401 token inválido, 403 no es jugador.
// /leave -> info:{match, event}; 409 cerrado / no abierto / el creador no puede bajarse / ya se bajó.
// /cancel (solo el creador) -> info:{match, alreadyCancelled}; 403 no es el creador, 409 el partido ya no está abierto.
// Optional `authToken` = the logged-in player's bearer: the back accepts it when no valid manage token is sent.
const manageHeaders = (manageToken, authToken) => {
  const headers = {};
  if (manageToken) headers["x-manage-token"] = manageToken;
  if (authToken) headers.Authorization = `Bearer ${authToken}`;
  return { headers };
};
export const getOpenMatchMeApi = (id, manageToken, authToken) =>
  axios.get(MAIN_API + OPEN_MATCH_ME_API(id), manageHeaders(manageToken, authToken));
export const leaveOpenMatchApi = (id, manageToken, authToken) =>
  axios.post(MAIN_API + LEAVE_OPEN_MATCH_API(id), {}, manageHeaders(manageToken, authToken));
export const cancelOpenMatchApi = (id, manageToken, authToken) =>
  axios.post(MAIN_API + CANCEL_OPEN_MATCH_API(id), {}, manageHeaders(manageToken, authToken));
// Partidos del jugador logueado (T14): info:{matches:[summary + me]}, incluye los que dejó (me.left).
export const getMyOpenMatchesApi = (token) =>
  axios.get(MAIN_API + GET_MY_OPEN_MATCHES_API, { headers: { Authorization: `Bearer ${token}` } });
export const getClubByIdApi = (id) => axios.get(MAIN_API + GET_CLUB_BY_ID_API(id));
export const getClubAvailabilityApi = (id, params = {}) =>
  axios.get(MAIN_API + GET_CLUB_AVAILABILITY_API(id), { params });
export const getClubPriceApi = (id, params = {}) =>
  axios.get(MAIN_API + GET_CLUB_PRICE_API(id), { params });
export const holdClubReservationApi = (data, token) =>
  axios.post(MAIN_API + HOLD_CLUB_RESERVATION_API, data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
export const createClubReservationApi = (data, token) =>
  axios.post(MAIN_API + CREATE_CLUB_RESERVATION_API, data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
// Cumpleaños en canchas. `token` (opcional) es el de la sesión: ata la reserva o el pedido a la cuenta.
export const getClubBirthdayAvailabilityApi = (id, params = {}) =>
  axios.get(MAIN_API + GET_CLUB_BIRTHDAY_AVAILABILITY_API(id), { params });
export const createClubBirthdayReservationApi = (id, data, token) =>
  axios.post(MAIN_API + CREATE_CLUB_BIRTHDAY_RESERVATION_API(id), data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
export const createClubBirthdayRequestApi = (id, data, token) =>
  axios.post(MAIN_API + CREATE_CLUB_BIRTHDAY_REQUEST_API(id), data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
// Link público del pedido (por token del email): vista y pago de la seña.
export const getBirthdayRequestApi = (token) =>
  axios.get(MAIN_API + GET_BIRTHDAY_REQUEST_API(encodeURIComponent(token)));
export const payBirthdayRequestApi = (token) =>
  axios.post(MAIN_API + PAY_BIRTHDAY_REQUEST_API(encodeURIComponent(token)), {});
/* ---------------------------- END club (canchas) API ---------------------------- */
/* ---------------------------- ALL beauty (turnos) API ---------------------------- */
const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});
export const getBeautySalonsApi = (params = {}) =>
  axios.get(MAIN_API + GET_BEAUTY_SALONS_API, { params });
export const getBeautySalonApi = (slugOrId) =>
  axios.get(MAIN_API + GET_BEAUTY_SALON_API(encodeURIComponent(slugOrId)));
// `items` = [{ serviceId, variantId?, addOnIds? }], sent as ONE query param with the JSON (axios encodes it).
export const getBeautyAvailabilityApi = ({ salonId, date, items = [], professionalId } = {}) => {
  const params = { salonId, date, items: JSON.stringify(items || []) };
  if (professionalId) params.professionalId = professionalId;
  return axios.get(MAIN_API + GET_BEAUTY_AVAILABILITY_API, { params });
};
export const holdBeautyAppointmentApi = (data, token) =>
  axios.post(MAIN_API + HOLD_BEAUTY_APPOINTMENT_API, data, { headers: authHeaders(token) });
export const createBeautyReservationApi = (data, token) =>
  axios.post(MAIN_API + CREATE_BEAUTY_RESERVATION_API, data, { headers: authHeaders(token) });
// Reagendar un turno beauty. Cliente logueado: por id de reserva; invitado: por token del link de gestión.
export const getReservationRescheduleOptionsApi = (id, date, token) =>
  axios.get(MAIN_API + `/api/app/reservation/${id}/reschedule-options`, {
    params: { date },
    headers: authHeaders(token),
  });
export const rescheduleReservationApi = (id, data, token) =>
  axios.post(MAIN_API + `/api/app/reservation/${id}/reschedule`, data, { headers: authHeaders(token) });
export const getManageReservationApi = (manageToken) =>
  axios.get(MAIN_API + `/api/app/manage/${encodeURIComponent(manageToken)}`);
export const getManageRescheduleOptionsApi = (manageToken, date) =>
  axios.get(MAIN_API + `/api/app/manage/${encodeURIComponent(manageToken)}/reschedule-options`, { params: { date } });
export const rescheduleManageReservationApi = (manageToken, data) =>
  axios.post(MAIN_API + `/api/app/manage/${encodeURIComponent(manageToken)}/reschedule`, data);
export const cancelManageReservationApi = (manageToken) =>
  axios.post(MAIN_API + `/api/app/manage/${encodeURIComponent(manageToken)}/cancel`, {});
// Reseña por link firmado (público, sin login): el token viaja en la URL del email/WhatsApp.
export const getReviewLinkApi = (token) =>
  axios.get(MAIN_API + `/api/app/review-link/${encodeURIComponent(token)}`);
export const createReviewByLinkApi = (token, data) =>
  axios.post(MAIN_API + `/api/app/review-link/${encodeURIComponent(token)}`, data);
// Lista de espera (público, sin login): anotarse, darse de baja y reservar desde el aviso por link firmado.
export const joinWaitlistApi = (data, token) =>
  axios.post(MAIN_API + "/api/app/waitlist", data, { headers: authHeaders(token) });
export const getWaitlistLeaveApi = (token) =>
  axios.get(MAIN_API + `/api/app/waitlist/leave/${encodeURIComponent(token)}`);
export const postWaitlistLeaveApi = (token) =>
  axios.post(MAIN_API + `/api/app/waitlist/leave/${encodeURIComponent(token)}`, {});
// Novedades y promociones (público, sin login): baja desde el link firmado que llega en cada mensaje.
export const getClientUnsubscribeApi = (token) =>
  axios.get(MAIN_API + `/api/app/clients/unsubscribe/${encodeURIComponent(token)}`);
export const postClientUnsubscribeApi = (token) =>
  axios.post(MAIN_API + `/api/app/clients/unsubscribe/${encodeURIComponent(token)}`, {});
export const getWaitlistClaimApi = (token) =>
  axios.get(MAIN_API + `/api/app/waitlist/claim/${encodeURIComponent(token)}`);
/* ---------------------------- END beauty (turnos) API ---------------------------- */
/* ---------------------------- ALL venue reviews API ---------------------------- */
export const getVenueReviewsApi = (barId, params = {}) =>
  axios.get(MAIN_API + GET_VENUE_REVIEWS_API(barId), { params });
export const createVenueReviewApi = (data, token) =>
  axios.post(MAIN_API + CREATE_VENUE_REVIEW_API, data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
/* ---------------------------- END venue reviews API ---------------------------- */
const getPreviewDeviceId = () => {
  try {
    if (typeof window === 'undefined') return '';
    const key = 'preview_device_id';
    let id = window.localStorage.getItem(key);
    if (!id && window.crypto?.randomUUID) {
      id = window.crypto.randomUUID();
      window.localStorage.setItem(key, id);
    }
    if (!id) {
      id = `pv_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
      window.localStorage.setItem(key, id);
    }
    return id || '';
  } catch (_) {
    return '';
  }
};

export const getPreviewEventByToken = (token) => {
  const deviceId = getPreviewDeviceId();
  return axios.get(MAIN_API + GET_PREVIEW_EVENT_API(token), {
    headers: deviceId ? { 'X-Preview-Device': deviceId } : {},
  });
};

export const getPreviewStatusByToken = (token) => {
  const deviceId = getPreviewDeviceId();
  return axios.get(MAIN_API + GET_PREVIEW_STATUS_API(token), {
    headers: deviceId ? { 'X-Preview-Device': deviceId } : {},
  });
};
export const resolveReferralTokenApi = (token) =>
  axios.get(`${MAIN_API}/api/referrals/${encodeURIComponent(token)}`);
/* ---------------------------- END event API ---------------------------- */
/* ---------------------------- ALL blog API ---------------------------- */
export const getLatestBlog = () => axios.get(MAIN_API + GET_LATEST_BLOG_API);
export const getAllBlog = (page = 1) => axios.get(MAIN_API + GET_ALL_BLOG_API + page);
export const getBlogById = (id) => axios.post(MAIN_API + GET_BLOG_BY_ID_API, { id });
/* ---------------------------- END blog API ---------------------------- */
/* ---------------------------- ALL sponser API ---------------------------- */
export const getSponsor = () => axios.get(MAIN_API + GET_SPONSOR_API);
/* ---------------------------- END sponser API ---------------------------- */
/* ---------------------------- ALL auth API ---------------------------- */
export const registerApi = (data) => axios.post(MAIN_API + REGISTER_API, data);
export const verifyEmailApi = (data) => axios.post(MAIN_API + VERIFY_EMAIL_API, data);
export const loginApi = (data) => axios.post(MAIN_API + LOGIN_API, data);
export const googleUserInfoApi = (token) =>
  axios.get(GOOGLE_USER_INFO_API, { headers: { Authorization: `Bearer ${token}` } });
export const socialLoginApi = (data) => axios.post(MAIN_API + SOCIAL_LOGIN_API, data);
export const checkEmailApi = (data) => axios.post(MAIN_API + CHECK_EMAIL_API, data);
export const verifyOtpApi = (data) => axios.post(MAIN_API + VERIFY_OTP_API, data);
export const forgotPasswordApi = (data) => axios.post(MAIN_API + FORGOT_PASSWORD_API, data);
export const getPopupImageApi = () => axios.get(MAIN_API + GET_POPUP_IMAGE_API);
/* ---------------------------- END auth API ---------------------------- */
/* ---------------------------- ALL appSettings API ---------------------------- */
// La configuracion de la app la piden siete pantallas al montarse (App, Layout, routes,
// LoginGate, Footer y los dos AppRoutes), y cada una hacia su propio viaje: en el pase desde el
// portal se veian tres GET identicos resueltos en fila. El arreglo va aca y no en las siete
// pantallas: la funcion comparte el viaje en curso y guarda la respuesta un rato.
//
// Cinco minutos y no para siempre porque la configuracion la cambia el staff desde el admin, y
// una pestana abierta todo el dia tiene que enterarse sin recargar. Si el pedido falla no se
// guarda nada, asi que el siguiente vuelve a intentar.
const VIGENCIA_DE_APP_SETTINGS = 5 * 60 * 1000;
let appSettingsEnVuelo = null;
let appSettingsGuardado = null;
let appSettingsVenceEn = 0;

export const getAppSettings = () => {
  if (appSettingsGuardado && Date.now() < appSettingsVenceEn) {
    return Promise.resolve(appSettingsGuardado);
  }

  if (appSettingsEnVuelo) return appSettingsEnVuelo;

  appSettingsEnVuelo = axios
    .get(MAIN_API + GET_APP_SETTINGS_API)
    .then((respuesta) => {
      appSettingsGuardado = respuesta;
      appSettingsVenceEn = Date.now() + VIGENCIA_DE_APP_SETTINGS;
      return respuesta;
    })
    .finally(() => {
      appSettingsEnVuelo = null;
    });

  return appSettingsEnVuelo;
};
/* ---------------------------- END appSettings API ---------------------------- */
/* ---------------------------- ALL contact API ---------------------------- */
export const sendMessageApi = (data) => axios.post(MAIN_API + SEND_MESSAGE_API, data);
export const submitRegretApi = (data) => axios.post(MAIN_API + SUBMIT_REGRET_API, data);
/* ---------------------------- END contact API ---------------------------- */
/* ---------------------------- ALL cart API ---------------------------- */
export const getCartApi = (token) => {
  return axios.get(MAIN_API + GET_CART_API, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const addCartApi = (data, token) => {
  return axios.post(MAIN_API + ADD_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const removeCartApi = (data, token) => {
  return axios.post(MAIN_API + REMOVE_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateCartApi = (data, token) => {
  return axios.post(MAIN_API + UPDATE_CART_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

/* ---------------------------- END cart API ---------------------------- */
/* ---------------------------- ALL discount API ---------------------------- */
export const applyDiscountApi = (data, token) => {
  return axios.post(MAIN_API + APPLY_DISCOUNT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getDiscountApi = (token) => {
  return axios.get(MAIN_API + GET_DISCOUNT_API, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
/* ---------------------------- END discount API ---------------------------- */
/* ---------------------------- ALL order API ---------------------------- */
export const createOrderApi = (data, token) => {
  return axios.post(MAIN_API + CHECKOUT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const verifyPaymentApi = (data, token) => {
  return axios.post(MAIN_API + VERIFY_PAYMENT_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getOrderApi = (token) => {
  return axios.get(MAIN_API + GET_ORDER_API, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
// User event history (grouped by event)
export const getMyEventsApi = (token) => {
  return axios.get(MAIN_API + GET_MY_EVENTS_API, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getMyEventDetailApi = (token, eventid) => {
  return axios.get(MAIN_API + GET_MY_EVENT_DETAIL_API(eventid), {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const getOrderStatusApi = (token, orderId) => {
  return axios.get(`${MAIN_API}/api/app/order/status/${orderId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const postReviewApi = (token, data) => {
  return axios.post(MAIN_API + POST_REVIEW_API, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getOrderByIdApi = (id) => {
  return axios.post(MAIN_API + GET_ORDER_BY_ID_API, { id });
};

/* ---------------------------- END order API ---------------------------- */

/* ---------------------------- USER PROFILE ---------------------------- */
export const updateUserProfileApi = (token, data) => {
  return axios.post(MAIN_API + UPDATE_PROFILE_API, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const changePasswordApi = (token, data) => {
  return axios.post(MAIN_API + CHANGE_PASSWORD_API, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteAccountApi = (token) => {
  return axios.post(MAIN_API + DELETE_ACCOUNT_API, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const fetchSetting = async () => {
  try {
    const response = await axios.get(MAIN_API + GET_APP_SETTINGS_API);
    return response.data.info;
  } catch (error) {
    console.error(error);
  }
};

/* ---------------------------- ALL Banner API ---------------------------- */
export const ADD_BANNER_API = '/api/admin/banners'
export const GET_ALL_BANNER_API = '/api/admin/banners'
export const GET_BANNER_BY_ID_API = (id) => `/api/admin/banners/${id}`
export const UPDATE_BANNER_API = (id) => `/api/admin/banners/${id}`
export const REORDER_BANNER_IMAGES_API = (id) => `/api/admin/banners/${id}/reorder`
export const DELETE_BANNER_API = (id) => `/api/admin/banners/${id}`
/* ---------------------------- END Banner API ---------------------------- */

/* ---------------------------- ALL Banner Image API ---------------------------- */
export const getActiveBannersApi = () =>
  axios.get(MAIN_API + GET_ACTIVE_BANNERS_API);

export const getActiveBannerByCodeApi = (code) =>
  axios.get(MAIN_API + GET_ACTIVE_BANNER_BY_CODE_API(code));

/* ---------------------------- END Banner Image API ---------------------------- */

/* ---------------------------- ZOCO API ---------------------------- */
// El pase desde el portal (pages/auth/EntrarDesdeZoco.jsx). Renovar no está acá: lo hace solo el
// interceptor de arriba, una vez para todas las pantallas.
export const zocoCanjearApi = (codigo) => axios.post(MAIN_API + ZOCO_CANJEAR_API, { codigo });
export const zocoSalirApi = (refreshToken) => axios.post(MAIN_API + ZOCO_SALIR_API, { refreshToken });
/* ---------------------------- END ZOCO API ---------------------------- */

/* ---------------------------- ORGANIZER API ---------------------------- */
const __authHeader = () => ({ Authorization: `Bearer ${store.getState().auth.accessToken}` });

export const organizerMeApi = () => axios.get(MAIN_API + "/api/organizer/me", { headers: __authHeader() });
export const organizerUpdateMeApi = (data) => axios.patch(MAIN_API + "/api/organizer/me", data, { headers: __authHeader() });

// Avisos del portal que el dueño silencia: { desactivadas: [clave] }; lo que no está en la lista está activo.
export const organizerNotificationPreferencesApi = () =>
  axios.get(MAIN_API + "/api/organizer/notification-preferences", { headers: __authHeader() });
export const organizerUpdateNotificationPreferencesApi = (desactivadas) =>
  axios.put(MAIN_API + "/api/organizer/notification-preferences", { desactivadas }, { headers: __authHeader() });

export const organizerListEventsApi = () => axios.get(MAIN_API + "/api/organizer/events/all", { headers: __authHeader() });
export const organizerAddEventApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/events/add", formData, { headers: { ...__authHeader(), "Content-Type": "multipart/form-data" } });
export const organizerUpdateEventApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/events/update", formData, { headers: { ...__authHeader(), "Content-Type": "multipart/form-data" } });
export const organizerDeleteEventApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/events/delete", data, { headers: __authHeader() });
export const organizerSendCertificatesApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/certificates/send", data, { headers: __authHeader() });
export const organizerSendWinnerCertificatesApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/certificates/send-winners", data, { headers: __authHeader() });
export const organizerPreviewCertificateApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/certificates/preview", data, {
    headers: __authHeader(),
    responseType: "blob",
  });

const __scannerPayload = (id) => {
  const payload = { id };
  payload.eventId = id;
  payload.eventid = id;
  return payload;
};
export const organizerScannerEventDetailsApi = (eventId) =>
  axios.post(MAIN_API + "/api/scanner/eventdetails", __scannerPayload(eventId), { headers: __authHeader() });
export const organizerScannerAttendeeListApi = (eventId) =>
  axios.post(MAIN_API + "/api/scanner/attendeelist", __scannerPayload(eventId), { headers: __authHeader() });
export const organizerManualCheckinReservationApi = (reservationId) =>
  axios.post(
    MAIN_API + "/api/scanner/reservationmanualcheckin",
    { reservationId },
    { headers: __authHeader() },
  );

export const organizerListScannersApi = () => axios.get(MAIN_API + "/api/organizer/scanners", { headers: __authHeader() });
export const organizerCreateScannerApi = (data) => axios.post(MAIN_API + "/api/organizer/scanners", data, { headers: __authHeader() });
export const organizerDeleteScannerApi = (id) => axios.delete(MAIN_API + `/api/organizer/scanners/${id}`, { headers: __authHeader() });
export const organizerAssignScannerApi = (data) => axios.post(MAIN_API + "/api/organizer/scanners/assign", data, { headers: __authHeader() });
export const organizerUnassignScannerApi = (data) => axios.post(MAIN_API + "/api/organizer/scanners/unassign", data, { headers: __authHeader() });
// Asignar/revocar scanner a un bar o club (reservas) — mirror de assign/unassign,
// consumido por Sellers.jsx cuando el toggle "Evento / Reserva" está en "Reserva".
export const organizerAssignScannerToBarApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/scanners/assign-bar", data, { headers: __authHeader() });
export const organizerUnassignScannerFromBarApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/scanners/unassign-bar", data, { headers: __authHeader() });

export const organizerAssignScannerWithTypesApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/scanners/assign-with-types", data, { headers: __authHeader() });
export const organizerListSellersApi = () => axios.get(MAIN_API + "/api/organizer/sellers", { headers: __authHeader() });
export const organizerCreateSellerApi = (data) => axios.post(MAIN_API + "/api/organizer/sellers", data, { headers: __authHeader() });
export const organizerDeleteSellerApi = (id) => axios.delete(MAIN_API + `/api/organizer/sellers/${id}`, { headers: __authHeader() });
export const organizerAssignSellerApi = (data) => axios.post(MAIN_API + "/api/organizer/sellers/assign", data, { headers: __authHeader() });
export const organizerUnassignSellerApi = (data) => axios.post(MAIN_API + "/api/organizer/sellers/unassign", data, { headers: __authHeader() });
export const organizerAssignSellerWithTypesApi = (data) => axios.post(MAIN_API + "/api/organizer/sellers/assign-with-types", data, { headers: __authHeader() });
export const organizerGetSellerReferralLinkApi = (sellerId, eventId) =>
  axios.get(MAIN_API + `/api/organizer/sellers/${sellerId}/referral-link`, {
    params: { eventId },
    headers: __authHeader(),
  });

/* ---------------------------- ORGANIZER: PHYSICAL / PREPRINTED TICKETS ---------------------------- */
export const organizerPhysicalListEventsApi = () =>
  axios.get(MAIN_API + "/api/organizer/physical-tickets/events", { headers: __authHeader() });

export const organizerPhysicalListTicketTypesApi = (eventId) =>
  axios.get(MAIN_API + "/api/organizer/physical-tickets/ticket-types", { params: { eventId }, headers: __authHeader() });

export const organizerPhysicalListBatchesApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/physical-tickets/batches", { params, headers: __authHeader() });

export const organizerPhysicalCreateBatchApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/physical-tickets/batches", data, { headers: __authHeader() });

export const organizerPhysicalGetBatchApi = (id) =>
  axios.get(MAIN_API + `/api/organizer/physical-tickets/batches/${id}`, { headers: __authHeader() });

export const organizerPhysicalVoidBatchApi = (id) =>
  axios.post(MAIN_API + `/api/organizer/physical-tickets/batches/${id}/void`, {}, { headers: __authHeader() });

export const organizerPhysicalClaimNextApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/physical-tickets/claim-next", data, { headers: __authHeader() });
/* ---------------------------- END ORGANIZER API ---------------------------- */

/* ---------------------------- ORGANIZER: ORDERS ---------------------------- */
export const organizerListOrdersApi = () => axios.get(MAIN_API + "/api/organizer/orders", { headers: __authHeader() });
export const organizerOrdersIncomeApi = () => axios.get(MAIN_API + "/api/organizer/orders/income", { headers: __authHeader() });

/* ---------------------------- ORGANIZER: COPIAR CONFIGURACIÓN DE OTRO LOCAL ---------------------------- */
// Locales de negocios del mismo titular o casa central, del tipo pedido ("club" | "bar" | "beauty").
// Solo se usan al crear un local: devuelven `info` = lista, y `info` = configuración saneada del elegido.
export const organizerListImportableLocalesApi = (tipo) =>
  axios.get(MAIN_API + "/api/organizer/locales/importables", { params: { tipo }, headers: __authHeader() });
export const organizerGetImportableConfigApi = (localId) =>
  axios.get(MAIN_API + `/api/organizer/locales/${encodeURIComponent(localId)}/config-importable`, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: BARS / TABLE RESERVATIONS ---------------------------- */
export const organizerListBarsApi = () =>
  axios.get(MAIN_API + "/api/organizer/bars", { headers: __authHeader() });
export const organizerGetBarApi = (id) =>
  axios.get(MAIN_API + `/api/organizer/bars/${id}`, { headers: __authHeader() });
export const organizerCreateBarApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/bars/add", formData, {
    headers: { ...__authHeader(), "Content-Type": "multipart/form-data" },
  });
export const organizerUpdateBarApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/bars/update", formData, {
    headers: { ...__authHeader(), "Content-Type": "multipart/form-data" },
  });
export const organizerDeleteBarApi = (barId) =>
  axios.post(MAIN_API + "/api/organizer/bars/delete", { barId }, { headers: __authHeader() });
export const organizerToggleBarApi = (barId) =>
  axios.post(MAIN_API + "/api/organizer/bars/toggle-status", { barId }, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: CLUBS / COURT RESERVATIONS ---------------------------- */
// Dedicated `/api/organizer/clubs/*` router (routes/organizer/clubs.routes.js),
// mirroring the bar organizer functions above 1:1 but NOT reused bar CRUD
// scoped by businessType — clubs.controller.js is a fully separate controller.
export const organizerListClubsApi = () =>
  axios.get(MAIN_API + "/api/organizer/clubs", { headers: __authHeader() });
export const organizerGetClubApi = (id) =>
  axios.get(MAIN_API + `/api/organizer/clubs/${id}`, { headers: __authHeader() });
export const organizerCreateClubApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/clubs/add", formData, {
    headers: { ...__authHeader(), "Content-Type": "multipart/form-data" },
  });
export const organizerUpdateClubApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/clubs/update", formData, {
    headers: { ...__authHeader(), "Content-Type": "multipart/form-data" },
  });
export const organizerDeleteClubApi = (clubId) =>
  axios.post(MAIN_API + "/api/organizer/clubs/delete", { clubId }, { headers: __authHeader() });
export const organizerToggleClubApi = (clubId) =>
  axios.post(MAIN_API + "/api/organizer/clubs/toggle-status", { clubId }, { headers: __authHeader() });

// Court statistics of a club for a date range. `params` = { from, to, sport?, courtId? } (YYYY-MM-DD);
// the front calls it twice, for the current and the comparison range.
export const organizerClubStatsApi = (clubId, params) =>
  axios.get(MAIN_API + ORG_CLUB_STATS_API(clubId), { params, headers: __authHeader() });

// Beauty statistics of the organizer's salon for a date range. `params` = { from, to, professionalId?, salonId? }
// (YYYY-MM-DD); the front calls it twice, for the current and the comparison range. A linked
// professional only gets their own numbers (the back forces the scope).
export const organizerBeautyStatsApi = (params) =>
  axios.get(MAIN_API + ORG_BEAUTY_STATS_API, { params, headers: __authHeader() });

export const organizerListTablesApi = (barId) =>
  axios.get(MAIN_API + "/api/organizer/tables", { params: { barId }, headers: __authHeader() });
export const organizerCreateTableApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tables/add", data, { headers: __authHeader() });
export const organizerUpdateTableApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tables/update", data, { headers: __authHeader() });
export const organizerDeleteTableApi = (tableId) =>
  axios.post(MAIN_API + "/api/organizer/tables/delete", { tableId }, { headers: __authHeader() });
// Bulk upsert of courts (Table docs) for a club (Unit 6 / PR6, task 6.2).
// POST /api/organizer/tables/bulk -> bulkUpsertTables. Plain JSON body (no
// file uploads, unlike bar/club create/update), mirrors the CRUD functions
// above. Server does full-replace-by-name semantics for the given barId.
export const organizerBulkUpsertTablesApi = (barId, tables) =>
  axios.post(MAIN_API + "/api/organizer/tables/bulk", { barId, tables }, { headers: __authHeader() });

export const organizerListReservationsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reservations", { params, headers: __authHeader() });
export const organizerGetDailyCourtScheduleApi = (params = {}, options = {}) =>
  axios.get(MAIN_API + "/api/organizer/reservations/daily-schedule", {
    params,
    headers: __authHeader(),
    ...options,
  });
export const organizerConfirmReservationApi = (reservationId) =>
  axios.post(MAIN_API + "/api/organizer/reservations/confirm", { reservationId }, { headers: __authHeader() });
export const organizerCancelReservationApi = (reservationId) =>
  axios.post(MAIN_API + "/api/organizer/reservations/cancel", { reservationId }, { headers: __authHeader() });
// Organizer cancels an open match ("Falta un jugador"): frees the court slot and notifies the players.
// Idempotent on the back (`info.alreadyCancelled`). Needs the `reservas:e` permission.
export const organizerCancelOpenMatchApi = (openMatchId) =>
  axios.post(MAIN_API + `/api/organizer/reservations/open-matches/${openMatchId}/cancel`, {}, { headers: __authHeader() });
export const organizerNoShowReservationApi = (reservationId) =>
  axios.post(MAIN_API + "/api/organizer/reservations/no-show", { reservationId }, { headers: __authHeader() });

// Internal (staff-created) reservation on a court, resolved on the same
// transactional overlap guard as the buyer flow (design.md V2/R7). POST
// /api/organizer/reservations -> createReservation controller.
export const organizerCreateReservationApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/reservations", data, { headers: __authHeader() });

// Lista de espera del local (organizador): las anotaciones activas de un día, anotar a alguien y quitar una anotación.
export const organizerListWaitlistApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/waitlist", { params, headers: __authHeader() });
export const organizerCreateWaitlistApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/waitlist", data, { headers: __authHeader() });
export const organizerDeleteWaitlistApi = (entryId) =>
  axios.delete(MAIN_API + `/api/organizer/waitlist/${encodeURIComponent(entryId)}`, { headers: __authHeader() });

export const organizerCreateReservationBlockApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/reservations/block", data, { headers: __authHeader() });
// `options.scope: "group"` deletes every row of the block's group (club blocks only); without it,
// only the given row goes.
export const organizerDeleteReservationBlockApi = (blockId, options = {}) =>
  axios.delete(MAIN_API + `/api/organizer/reservations/block/${blockId}`, {
    headers: __authHeader(),
    ...(options?.scope ? { params: { scope: options.scope } } : {}),
  });

// Turnos fijos (series semanales de una cancha). Preview reports each date's state without
// writing; create books the available ones (409 + `skipped` when none is); list returns the
// club's active series; cancel takes the series from `from` (YYYY-MM-DD, default today) on.
export const organizerPreviewReservationSeriesApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/reservations/series/preview", data, { headers: __authHeader() });
export const organizerCreateReservationSeriesApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/reservations/series", data, { headers: __authHeader() });
export const organizerListReservationSeriesApi = (clubId) =>
  axios.get(MAIN_API + "/api/organizer/reservations/series", { params: { clubId }, headers: __authHeader() });
export const organizerCancelReservationSeriesApi = (seriesId, from) =>
  axios.post(
    MAIN_API + `/api/organizer/reservations/series/${seriesId}/cancel`,
    from ? { from } : {},
    { headers: __authHeader() },
  );

// Bandeja de pedidos de cumpleaños del club (reserva por aprobación). list -> { requests, counts, total, page,
// limit }; detail trae además la reserva; accept responde 409 si el horario ya no está libre.
export const organizerListBirthdayRequestsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reservations/birthdays/requests", { params, headers: __authHeader() });
export const organizerGetBirthdayRequestApi = (requestId) =>
  axios.get(MAIN_API + `/api/organizer/reservations/birthdays/requests/${requestId}`, { headers: __authHeader() });
export const organizerAcceptBirthdayRequestApi = (requestId, data = {}) =>
  axios.post(MAIN_API + `/api/organizer/reservations/birthdays/requests/${requestId}/accept`, data, { headers: __authHeader() });
export const organizerProposeBirthdayRequestApi = (requestId, data = {}) =>
  axios.post(MAIN_API + `/api/organizer/reservations/birthdays/requests/${requestId}/propose`, data, { headers: __authHeader() });
export const organizerRejectBirthdayRequestApi = (requestId, data = {}) =>
  axios.post(MAIN_API + `/api/organizer/reservations/birthdays/requests/${requestId}/reject`, data, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: COUPONS ---------------------------- */
export const organizerCreateCouponApi = (data) => axios.post(MAIN_API + "/api/organizer/coupons/create", data, { headers: __authHeader() });
export const organizerListCouponsApi = () => axios.get(MAIN_API + "/api/organizer/coupons/all", { headers: __authHeader() });
export const organizerUpdateCouponApi = (data) => axios.post(MAIN_API + "/api/organizer/coupons/update", data, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: EVENT SPONSORS ---------------------------- */
export const organizerAddSponsorApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/eventsponsor/addeventsponsor", formData, { headers: { ...__authHeader(), "Content-Type": "multipart/form-data" } });
export const organizerUpdateSponsorApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/eventsponsor/updateeventsponsor", formData, { headers: { ...__authHeader(), "Content-Type": "multipart/form-data" } });
export const organizerListSponsorsApi = () => axios.get(MAIN_API + "/api/organizer/eventsponsor/alleventsponsor", { headers: __authHeader() });
export const organizerDeleteSponsorApi = (data) => axios.post(MAIN_API + "/api/organizer/eventsponsor/deleteeventsponsor", data, { headers: __authHeader() });
export const organizerSponsorsByEventApi = (data) => axios.post(MAIN_API + "/api/organizer/eventsponsor/geteventsponsorbyeventid", data, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: REPORTS ---------------------------- */
export const organizerReportsDaywiseIncomeApi = () => axios.get(MAIN_API + "/api/organizer/reports/daywiseincome", { headers: __authHeader() });
export const organizerReportsTotalsApi = () => axios.get(MAIN_API + "/api/organizer/reports/totals", { headers: __authHeader() });
export const organizerReportsExpressStatusApi = () => axios.get(MAIN_API + "/api/organizer/reports/express/status", { headers: __authHeader() });
export const organizerReportsExpressSyncApi = (asyncMode = true) =>
  axios.post(MAIN_API + `/api/organizer/reports/express/sync${asyncMode ? "?async=1" : ""}`, {}, { headers: __authHeader() });
export const organizerReportsExpressTotalsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/express/totals", { params, headers: __authHeader() });
export const organizerReportsExpressDaywiseApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/express/daywise", { params, headers: __authHeader() });
export const organizerReportsExpressSalesApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/express/sales", { params, headers: __authHeader() });
export const organizerReportsExpressDayDetailsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/express/day-details", { params, headers: __authHeader() });
export const organizerReportsExpressCustomApi = (body = {}) =>
  axios.post(MAIN_API + "/api/organizer/reports/express/custom", body, { headers: __authHeader() });
export const organizerReportsExpressArticlesApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/express/articles", { params, headers: __authHeader() });
export const organizerReportsManualPosTotalsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/manual-pos/totals", { params, headers: __authHeader() });
export const organizerReportsManualPosDaywiseApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/manual-pos/daywise", { params, headers: __authHeader() });
export const organizerReportsManualPosDayDetailsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/reports/manual-pos/day-details", { params, headers: __authHeader() });

/* ---------------------------- ORGANIZER: MARKETING ---------------------------- */
export const organizerMarketingSummaryApi = () =>
  axios.get(MAIN_API + "/api/organizer/marketing/summary", { headers: __authHeader() });

export const organizerMarketingAudienceCountApi = (body = {}) =>
  axios.post(MAIN_API + "/api/organizer/marketing/audience/count", body, { headers: __authHeader() });

export const organizerMarketingListCampaignsApi = () =>
  axios.get(MAIN_API + "/api/organizer/marketing/campaigns", { headers: __authHeader() });

export const organizerMarketingSendEmailApi = (body = {}) =>
  axios.post(MAIN_API + "/api/organizer/marketing/campaigns/send-email", body, { headers: __authHeader() });

export const organizerMarketingUploadImageApi = (formData) =>
  axios.post(MAIN_API + "/api/organizer/marketing/upload-image", formData, {
    headers: { ...__authHeader() },
  });

export const organizerMarketingTestEmailApi = () =>
  axios.post(MAIN_API + "/api/organizer/marketing/test-email", {}, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: TICKET TYPES ---------------------------- */
export const organizerTicketTypesByEventApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tickettypes/by-event", data, { headers: __authHeader() });
export const organizerCreateTicketTypeApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tickettypes/create", data, { headers: __authHeader() });
export const organizerUpdateTicketTypeApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tickettypes/update", data, { headers: __authHeader() });
export const organizerDeleteTicketTypeApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/tickettypes/delete", data, { headers: __authHeader() });

/* ---------------------------- ORGANIZER: GIFT TICKETS ---------------------------- */
export const organizerCreateGiftTicketsApi = (data) =>
  axios.post(MAIN_API + "/api/organizer/gifts/create", data, { headers: __authHeader() });
export const organizerListGiftTicketsApi = (params = {}) =>
  axios.get(MAIN_API + "/api/organizer/gifts", { headers: __authHeader(), params });
export const organizerGiftReferralLinkApi = (eventId) =>
  axios.get(MAIN_API + "/api/organizer/gifts/referral-link", {
    headers: __authHeader(),
    params: { eventId },
  });
export const organizerUpdateGiftApi = (orderId, data) =>
  axios.patch(MAIN_API + "/api/organizer/gifts/" + orderId, data, { headers: __authHeader() });
export const organizerDeleteGiftApi = (orderId) =>
  axios.delete(MAIN_API + "/api/organizer/gifts/" + orderId, { headers: __authHeader() });

/* ---------------------------- TICKET TRANSFER ---------------------------- */
export const acceptTicketTransferApi = (accessToken, token) =>
  axios.post(
    `${MAIN_API}${ACCEPT_TICKET_TRANSFER_API}?token=${encodeURIComponent(token)}`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
export const initiateTicketTransferApi = (accessToken, ticketId, toEmail) =>
  axios.post(
    `${MAIN_API}${INITIATE_TICKET_TRANSFER_API(ticketId)}`,
    { toEmail },
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
/* ---------------------------- END TICKET TRANSFER ---------------------------- */
